import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

async function fetchTypes(url, flat) {
  const data = await HelpersPresenter.get(url)
  return flat ? Object.keys(data) : data
}

export default class HelpersPresenter extends EntityPresenter {
  static urn = 'helpers'

  static async nodeTypes(flat = true) {
    return fetchTypes('nodes/types', flat)
  }

  static async sensorTypes(flat = true) {
    return fetchTypes('sensors/types', flat)
  }

  static async sensorModels(flat = true) {
    return fetchTypes('sensors/models', flat)
  }

  static async sensorStatuses(flat = true) {
    return fetchTypes('sensors/statuses', flat)
  }

  static async nodesStatuses(flat = true) {
    return fetchTypes('nodes/statuses', flat)
  }

  static async modelsTemplate() {
    return await HelpersPresenter.get('models/template')
  }

  static async modelsTemplateTest(body) {
    return await HelpersPresenter.post('models/driver/test', body)
  }
  static async fieldTypes(body) {
    return await HelpersPresenter.get('commands-schema-definition/field-types')
  }
}

bindPresenterMethods(HelpersPresenter)
